import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { ComboboxItem, ComboboxTagInput, ComboboxTagInputProps } from '@src/components/sco/ComboboxTagInput';
import { ScoIndustry } from '@src/graphql-types';
import { gql } from '@src/lib/gql';
import React, { useEffect, useState } from 'react';
export const CompanyIndustryComboboxInput = props => {
  const $ = _c(24);
  let t0;
  if ($[0] !== props.defaultValue) {
    t0 = props.defaultValue || [];
    $[0] = props.defaultValue;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [industryItems, setIndustryItems] = useState(t0);
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const [industryOptions, setIndustryOptions] = useState(t1);
  let t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = gql`
      query {
        scoIndustries {
          id
          key
          title
        }
      }
    `;
    t3 = {
      ssr: false
    };
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  const query = useQuery(t2, t3);
  let t4;
  if ($[5] !== industryItems || $[6] !== props) {
    t4 = () => {
      if (props.onChange) {
        props.onChange(industryItems);
      }
    };
    $[5] = industryItems;
    $[6] = props;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== industryItems) {
    t5 = [industryItems];
    $[8] = industryItems;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  useEffect(t4, t5);
  let t6;
  if ($[10] !== query.data) {
    t6 = () => {
      if (query.data?.scoIndustries) {
        setIndustryOptions(query.data.scoIndustries);
      }
    };
    $[10] = query.data;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = query.data?.scoIndustries?.length;
  let t8;
  if ($[12] !== t7) {
    t8 = [t7];
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  useEffect(t6, t8);
  const t9 = props.comboboxTagInputProps;
  let t10;
  if ($[14] !== props.defaultValue) {
    t10 = props.defaultValue || [];
    $[14] = props.defaultValue;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  const t11 = query.loading;
  let t12;
  if ($[16] !== industryOptions) {
    t12 = industryOptions.map(_temp);
    $[16] = industryOptions;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = items => {
      setIndustryItems(items);
    };
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== props.comboboxTagInputProps || $[20] !== query.loading || $[21] !== t10 || $[22] !== t12) {
    t14 = <ComboboxTagInput {...t9} defaultSelectedItems={t10} itemsAreFiltered={false} itemsAreLoading={t11} items={t12} onChange={t13} />;
    $[19] = props.comboboxTagInputProps;
    $[20] = query.loading;
    $[21] = t10;
    $[22] = t12;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  return t14;
};
function _temp(industry) {
  return {
    key: industry.key,
    title: industry.title
  };
}